var Vue = require('vue');
var Multiselect = require('vue-bootstrap').Multiselect;

module.exports = function() {
    new Vue({
        el: '#action-selector',
        components: {
            'multiselect': Multiselect
        }
    });
};